<template>
  <v-app id="inspire">
    <mo-header></mo-header>
    <br />
    <v-content>
      <v-container fluid grid-list-xl>
        <center><img style="padding-top: 7%;" src="../shared/assets/images/3dloader.gif" /></center>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>

import Vue from 'vue';
import router from '@/router';
import { mapGetters } from 'vuex';

export default {
  data: () => ({
  }),
  computed: {
    ...mapGetters([
      'objAuthorize',
    ])
  },
  mounted() {

    if (this.objAuthorize.type == '6') {
      router.replace('/reports/sales-order-reports');
    } else {
      if(this.objAuthorize.privileges.indexOf('VIEW_QUOTES') == -1) {
        router.replace('reports/sales-order-reports?p=1');
      } else {
        router.replace('/reports/quote-reports-lite?p=1');
      }
    }

  }
}
</script>

<style scoped>
@import '../shared/assets/css/shared.css'
</style>
